module.exports = __webpack_public_path__ + "static/media/girl-placeholder.706c696a.png";